import { FleekError } from './FleekError';

type ProjectSiteLimitExceededErrorOptions = Record<string, never>;

export class ProjectSiteLimitExceededError extends FleekError<ProjectSiteLimitExceededErrorOptions> {
  public name = 'ProjectSiteLimitExceededError';

  toString = () => `Your project is growing! You've reached the maximum number of sites for this project. Upgrade your plan at https://fleek.xyz/pricing to add more sites. Need assistance? Our Support team is ready to help.`
}
